import { __rest as o } from "../_virtual/_tslib.js";
import { jsx as r } from "react/jsx-runtime";
import { Col as t } from "react-styled-flexboxgrid";
var e = function e(_e) {
  var i = _e.colSizes,
    s = o(_e, ["colSizes"]);
  return r(t, Object.assign({
    $colSizes: i
  }, s, {
    children: _e.children
  }));
};
e.defaultProps = {
  colSizes: {}
};
export { e as default };